/*
 * サブシステム名：請求消込
 * 機能名：未入金一覧
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdCheckbox from '@/components/DdCheckbox'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'

export default {
  name: 'MiNyukinList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      seikyusakiCd: '',
      nyukinYoteiYmdFromString: '',
      nyukinYoteiYmdToString: '',
      tantoCd: '',
      nyukinYoteiChoka: ''
    },
    headersJininList: header.mstJininHeaders,
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdDateBox,
    DdCheckbox
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        // 表示フォーマット編集
        if (elem.seikyuYmd !== null) {
          elem.seikyuYmdDisp = filter.dateFormatter(elem.seikyuYmd)
        }
        if (elem.nyukinYoteiYmd !== null) {
          elem.nyukinYoteiYmdDisp = filter.dateFormatter(elem.nyukinYoteiYmd)
        }
        elem.seikyuKingakuDisp = filter.numericFormatter(elem.seikyuKingaku)
        elem.nyukinKingakuDisp = filter.numericFormatter(elem.nyukinKingaku)
        elem.minyukinKingakuDisp = filter.numericFormatter(elem.minyukinKingaku)
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      jininList: 'DDMasters/mstJinin',
      seikyusakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki'
    }),
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredSeikyusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.seikyusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstjinin', 'vwcmsttorihikisakigetseikyusaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('D2BCLD0040.defineHeaderPromise')
            self.headers = [
              { text: '請求先', value: 'seikyusakiNm' },
              { text: '請求日', value: 'seikyuYmdDisp', align: 'center' },
              { text: '入金予定日', value: 'nyukinYoteiYmdDisp', align: 'center' },
              { text: '請求No', value: 'seikyuNo' },
              { text: '受注担当者', value: 'tantoNm' },
              { text: '請求金額', value: 'seikyuKingakuDisp', align: 'end' },
              { text: '入金金額', value: 'nyukinKingakuDisp', align: 'end' },
              { text: '未入金額', value: 'minyukinKingakuDisp', align: 'end' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              seikyusakiCd: '',
              nyukinYoteiYmdFromString: '',
              nyukinYoteiYmdToString: '',
              tantoCd: '',
              nyukinYoteiChoka: true
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('D2BCLD0040.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          if (Object.keys(c).length !== 0) {
            var nyukinYoteiChokaBool = c.nyukinYoteiChoka === 'true'
            self.conditions.nyukinYoteiChoka = nyukinYoteiChokaBool
          }
          console.log('D2BCLD0040.savedInputRestorePromise', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('D2BCLD0040.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('D2BCLD0040.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCD2bcld0040/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            nyukinYoteiChoka: self.conditions.nyukinYoteiChoka
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              seikyusakiCd: '',
              nyukinYoteiYmdFromString: '',
              nyukinYoteiYmdToString: '',
              tantoCd: '',
              nyukinYoteiChoka: true
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCD2bcld0040/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onReportButtonClick: function (e) {
      console.log(e)
      // todo:レポート出力
      this.HttpClient
        .requestFileByPost('/api/v1/vwCD2bcld0040/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfdownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    searchValidate: function () {
      console.log('searchValidate')
      // 入金予定日の大小チェック
      const msg = validators.compareDate(this.conditions.nyukinYoteiYmdFromString, this.conditions.nyukinYoteiYmdToString)
      if (msg !== undefined) {
        this.$refs.nyukinYoteiYmdFromString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.nyukinYoteiYmdToString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      return true
    }
  }
}
